module.exports = __webpack_public_path__ + "static/media/desktop_overlay.985dd8d8.jpg";